import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  contrasenaActual: Yup.string().required(),
  contrasenaNueva: Yup.string().required(),
  contrasenaNuevaRepeat: Yup.string().required()
})
